import React from 'react';
import { FileUploadItem, Red90 } from '@traceair/tds';
import { style } from 'typestyle';
import { GcpRequestData, GcpRequestUploadFile, useUploadStore } from '../../../../../../store/uploadStore';
import { Customer, Site } from '../../../../../../types';
import { recalcGcpStats } from '../gcpRequestUploadFiles/useHandleGcpFileUpload';

const fileItemStyle = style({
  $nest: {
    '& .ta-file-item-size': {
      color: Red90,
      whiteSpace: 'break-spaces',
    },
  },
});

interface Props {
  upload: GcpRequestUploadFile;
  customer: Customer;
  site: Site;
  gcpRequest: GcpRequestData;
}

export const GcpMeasurementErrorItem: React.FC<Props> = ({ upload, customer, site, gcpRequest }) => {
  const { setGcpRequest } = useUploadStore();

  const removeUpload = () => {
    upload.abortController.abort();
    const idx = gcpRequest.measurementUploads.indexOf(upload);
    if (idx !== -1) gcpRequest.measurementUploads.splice(idx, 1);
    if (upload.uploadedUrl) {
      const fileIdx = gcpRequest.measurements.indexOf(upload.uploadedUrl);
      if (fileIdx !== -1) gcpRequest.measurements.splice(fileIdx, 1);
    }
    recalcGcpStats(gcpRequest);
    setGcpRequest(customer.id, site.id, gcpRequest);
  };

  return (
    <>
      <FileUploadItem
        className={fileItemStyle}
        file={{
          uid: `${upload.file.name}-${upload.file.size}`,
          name: upload.file.name,
          size: upload.file.size,
          type: upload.file.type || '',
          status: 'error',
          response: upload.parseResult?.error ?? 'Unknown error occurred while processing the file. Please try again.',
        }}
        onRemove={removeUpload}
      />
    </>
  );
};
